import React, { FC } from 'react';
import { ListCards } from '@/components/molecules/ListCards/render';

import block from './block.json';

/**
 * COMPONENT
 */
export const ListKeyfactsIcon: FC<ListCardsProps> & BlockConfigs = (props) => {
	return <ListCards {...props} />;
};

ListKeyfactsIcon.slug = block.slug;
ListKeyfactsIcon.title = block.title;
